/**
 * Progressive enhancement for the collapsible description
 * (snippets/product-soulog-description.liquid).
 *
 * Expanding and collapsing are pure CSS — a hidden checkbox and <label>s — and
 * nothing here runs before or during the first paint, so this file cannot
 * reintroduce the load-time flash the component was built to remove. Without it
 * the component still works; it just animates less well and can drop the reader
 * somewhere unexpected on collapse.
 *
 * 1. Height for the easing. The expanded state is capped at 400vh in CSS so no
 *    description is ever clipped, but a transition toward a ceiling far above
 *    the real height finishes early and reads as a snap. Substituting the
 *    element's own scrollHeight makes the easing track the actual movement.
 *
 * 2. Scroll compensation. A long description can add ~1000px, pushing
 *    "Read less" below the fold; the reader scrolls down to reach it and the
 *    collapse takes that height away again. Chrome's scroll anchoring only
 *    compensated ~15px of a measured 1059px collapse, leaving the reader far
 *    below where they started, so pull the block back into view.
 */
(function () {
	var DESKTOP = window.matchMedia("(min-width: 768px)");

	function headerOffset() {
		var px = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
		return isNaN(px) ? 0 : px;
	}

	document.querySelectorAll(".pi-desc__state").forEach(function (state) {
		var desc = state.nextElementSibling;
		if (!desc || !desc.classList.contains("pi-desc")) return;
		var body = desc.querySelector(".pi-desc__body");
		if (!body) return;

		// Once the expansion has played out, release the pinned height: anything
		// that grows later (a late-loading image in the description) would
		// otherwise be clipped by a height measured before it arrived.
		body.addEventListener("transitionend", function (event) {
			if (event.propertyName === "max-height" && state.checked && DESKTOP.matches) {
				body.style.maxHeight = "none";
			}
		});

		state.addEventListener("change", function () {
			// Below 768px the body is a scrolling sheet, not a growing box —
			// pinning a pixel height there would break its own overflow.
			var animateHeight = DESKTOP.matches;

			if (state.checked) {
				if (animateHeight) body.style.maxHeight = body.scrollHeight + "px";
				// Expanding only ever adds height below the reader.
				return;
			}

			// Collapse: `max-height: none` cannot be interpolated, so restore a
			// concrete height and force it to be rendered before handing control
			// back to the stylesheet — otherwise the collapse just snaps.
			if (animateHeight) {
				body.style.maxHeight = body.scrollHeight + "px";
				void body.offsetHeight;
			}
			body.style.maxHeight = "";

			var top = desc.getBoundingClientRect().top - headerOffset() - 16;
			if (top >= 0) return; // still on screen — leave the reader alone

			// `behavior: "instant"` is required: the theme sets
			// `html { scroll-behavior: smooth }`, which would otherwise animate
			// this correction and let the reader watch the page fly back.
			window.scrollBy({ top: top, behavior: "instant" });
		});

		// A pinned pixel height would survive a resize and clip the text at the
		// new width; drop it and let the stylesheet ceiling take over again.
		DESKTOP.addEventListener("change", function () {
			body.style.maxHeight = "";
		});
	});
})();
